export default __webpack_public_path__ + "static/media/255.5db558de.jpg";